import { render, staticRenderFns } from "./CompetitionListLink.vue?vue&type=template&id=1ed7095f&scoped=true"
import script from "./CompetitionListLink.vue?vue&type=script&lang=js"
export * from "./CompetitionListLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed7095f",
  null
  
)

export default component.exports